import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { cx } from '../classname.js';
import { styleMapper } from './styleMapper/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapAdsStyles = function mapAdsStyles(input, context) {
  var styles = Object.keys(input).reduce(function (acc, key) {
    var resolver = styleMapper[key];
    var value = input[key];
    var _resolver = resolver(value, context),
      classNames = _resolver.classNames,
      style = _resolver.style;
    return {
      classNames: [].concat(_toConsumableArray(acc.classNames), _toConsumableArray(classNames || [])),
      style: _objectSpread(_objectSpread({}, acc.style), style || {})
    };
  }, {
    classNames: [],
    style: {}
  });
  return {
    className: Object.keys(styles.classNames).length ? cx(styles.classNames).trim() : undefined,
    style: Object.keys(styles.style).length ? styles.style : undefined
  };
};

export { mapAdsStyles };
//# sourceMappingURL=mapAdsStyles.js.map
